module.exports = __webpack_public_path__ + "img/success-thumb.ef8d8582.svg";